export function HelpersFixers (pEditor, pHelpers)
{
  let fixWebKitSpanTM,
      isWebKitSpansCollected = false,
      webKitSpans = [],
      webKitNewSpans = {},
      fixGeckoBodyBackgroundCounter,
      fixIELastLineCounter = 3;


  this.fixWebKitSpan = (isCollect) =>
  {
    if (!BEditor.browser.isWebKit)
    {
      return;
    }

    let i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('SPAN'),
        spanIndex;

    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.setExcludeWordCheck();

    if (isCollect != null)
    {
      isWebKitSpansCollected = !isCollect;
    }

    if (isWebKitSpansCollected)
    {
      if (fixWebKitSpanTM) clearTimeout(fixWebKitSpanTM);

      for (i = elements.length; i--;)
      {
        if (elements[i].hasAttribute('style'))
        {
          spanIndex = elements[i].style.fontFamily.replace(/[\S\s]*?WaWebKitSavedSpanIndex_(\d+)/, '$1');

          if (spanIndex)
          {
            elements[i].setAttribute('style', webKitSpans[spanIndex] || '');
          }
          else
          {
            elements[i].outerHTML = elements[i].innerHTML;
          }
        }
        else
        {
          spanIndex = elements[i].getAttribute('data-wacontent');

          if (spanIndex != null && !(spanIndex in webKitNewSpans))
          {
            elements[i].outerHTML = elements[i].innerHTML;
          }
        }
      }

      webKitSpans.splice(0, webKitSpans.length);
      webKitSpans.splice(0, webKitNewSpans.length);
      isWebKitSpansCollected = false;

      pEditor.undoRedo.saveUndoDo(true);
      pEditor.undoRedo.isStopSaveUndo = false;
    }
    else
    {
      webKitSpans.splice(0, webKitSpans.length);
      webKitSpans.splice(0, webKitNewSpans.length);

      for (i = 0; i < elements.length; i++)
      {
        if (elements[i].hasAttribute('style'))
        {
          webKitSpans[i] = elements[i].getAttribute('style');
          elements[i].style.fontFamily = (elements[i].style.fontFamily ? elements[i].style.fontFamily : BEditor.styleHelpers.getElementStyle(elements[i], 'fontFamily')) + ', WaWebKitSavedSpanIndex_' + i;
        }
        else
        {
          spanIndex = elements[i].getAttribute('data-wacontent');

          if (spanIndex != null && !(spanIndex in webKitNewSpans))
          {
            webKitNewSpans[spanIndex] = true;
          }
        }
      }

      isWebKitSpansCollected = true;
    }
  };


  this.fixWebKitList = () =>
  {
    if (BEditor.browser.isWebKit)
    {
      let lists = pEditor.iFrameDoc.body.querySelectorAll('OL:not([data-wacontent]),UL:not([data-wacontent])');

      for (let i = lists.length; i--;)
      {
        let parentElement = lists[i].parentNode;

        if (parentElement && (/^(p|h[1-6]|pre|li|blockquote|center|dt|dd|td|th|address|marquee)$/i).test(parentElement.nodeName) && (new RegExp(`^(?:\s|&nbsp;|<br>)*${lists[i].outerHTML}(?:\s|&nbsp;|<br>)*$`, 'i')).test(parentElement.innerHTML))
        {
          parentElement.outerHTML = lists[i].outerHTML;
        }
      }
    }
  };


  this.fixGeckoIETable = (keyCode) =>
  {
    let tdParent,
        elTable,
        elTds,
        newTag;

    if ((tdParent = pHelpers.element.getParentElementByTagsNames(null, pEditor.checkThTdTags)) && (elTable = pHelpers.element.getParentElementFromElementByTagsNames(tdParent, /^TABLE$/)) && (elTds = elTable.querySelectorAll('TH, TD')) &&
        ((keyCode === 37 && tdParent === elTds[0]) || (keyCode === 39 && tdParent === elTds[elTds.length - 1])))
    {
      newTag = document.createElement('P');
      newTag.innerHTML = (BEditor.browser.isIE ? '&nbsp;' : '<br>');
      elTable.parentNode.insertBefore(newTag, ((keyCode === 37) ? elTable : null));
      pEditor.range.setCursorPoint(newTag, true);
    }
  };


  this.fixGeckoBodyBackground = (isStart) =>
  {
    let k, n;

    if (!BEditor.browser.isGecko)
    {
      return;
    }

    for (k in pEditor.bodyStyles)
    {
      if (pEditor.bodyStyles.hasOwnProperty(k))
      {
        for (n in pEditor.bodyStyles[k])
        {
          if (pEditor.bodyStyles[k].hasOwnProperty(n) && pEditor.bodyStyles[k][n] != null)
          {
            if (k === 'background' || pEditor.bodyStyles[k][n] !== BEditor.styleHelpers.getElementStyle(pEditor.iFrameDoc.body, n))
            {
              pEditor.iFrameDoc.body.style[n] = pEditor.bodyStyles[k][n];
            }
          }
        }
      }
    }

    if (isStart)
    {
      fixGeckoBodyBackgroundCounter = 0;
    }

    if (fixGeckoBodyBackgroundCounter < 5)
    {
      fixGeckoBodyBackgroundCounter++;
      setTimeout(this.fixGeckoBodyBackground, 100 * fixGeckoBodyBackgroundCounter);
    }
  };


  const removeFixGeckoTables = (htmlSource, newTable) =>
  {
    let i,
        waTables;

    if (!BEditor.browser.isGecko)
    {
      return;
    }

    waTables = (newTable) ? [newTable] : htmlSource.getElementsByTagName('TABLE');

    for (i = 0; i < waTables.length; i++)
    {
      if (waTables[i].getAttribute('watable', 0))
      {
        if (waTables[i].getAttribute('wamarginleft', 0))
        {
          waTables[i].style.marginLeft = '';
          waTables[i].removeAttribute('wamarginleft', 0);
        }

        if (waTables[i].getAttribute('wamarginright', 0))
        {
          waTables[i].style.marginRight = '';
          waTables[i].removeAttribute('wamarginright', 0);
        }

        if (waTables[i].getAttribute('wamargintop', 0))
        {
          waTables[i].style.marginTop = '';
          waTables[i].removeAttribute('wamargintop', 0);
        }

        if (waTables[i].getAttribute('wamarginbottom', 0))
        {
          waTables[i].style.marginBottom = '';
          waTables[i].removeAttribute('wamarginbottom', 0);
        }
      }
    }
  };


  this.setFixGeckoTables = (attr) =>
  {
    if (!BEditor.browser.isGecko)
    {
      return;
    }

    attr.htmlSource = attr.htmlSource || pEditor.iFrameDoc.body;

    pEditor.undoRedo.isStopSaveUndo = true;
    pEditor.contentChecker.setExcludeWordCheck();

    if (attr.isRemove || attr.isBoth)
    {
      removeFixGeckoTables(attr.htmlSource, (attr.newTable || null));
    }

    if (attr.isFix || attr.isBoth)
    {
      BEditor.utils.fixGeckoTables(pEditor.iFrame, (attr.newTable || null));
    }

    pEditor.undoRedo.saveUndoDo(true);
    pEditor.undoRedo.isStopSaveUndo = false;
  };


  this.fixGeckoAlign = () =>
  {
    let i,
        elements;

    if (!BEditor.browser.isGecko)
    {
      return;
    }

    elements = pEditor.iFrameDoc.body.querySelectorAll('[style*="text-align"]');

    for (i = 0; i < elements.length; i++)
    {
      elements[i].setAttribute('align', elements[i].style.textAlign);
      elements[i].style.removeProperty('text-align');

      if (elements[i].getAttribute('style') === '')
      {
        elements[i].removeAttribute('style');
      }
    }
  };


  this.fixIEListDiv = () =>
  {
    if (BEditor.browser.isIE)
    {
      let lists = pEditor.iFrameDoc.body.querySelectorAll('OL:not([data-wacontent]),UL:not([data-wacontent])');

      for (let i = lists.length; i--;)
      {
        let divs = lists[i].querySelectorAll('DIV');

        for (let n = divs.length; n--;)
        {
          if (!divs[n].hasAttribute('data-wacontent') || divs[n].getAttribute('data-wacontenttag') !== 'DIV')
          {
            divs[n].outerHTML = divs[n].innerHTML;
          }
        }
      }
    }
  };


  this.fixIELastLine = () =>
  {
    let element,
        elements,
        lastChild,
        isCreate,
        elementTag = (pEditor.isEditorInViewMode ? 'DIV' : 'INPUT');

    if (fixIELastLineCounter > 2)
    {
      elements = pEditor.iFrameDoc.body.querySelectorAll(elementTag + '[data-waielastline]');
      isCreate = (!elements || elements.length !== 1 || elements[0] !== pEditor.iFrameDoc.body.lastChild);
      fixIELastLineCounter = 0;
    }
    else
    {
      lastChild = pEditor.iFrameDoc.body.lastChild;
      isCreate = (!lastChild || lastChild.nodeType !== 1 || !lastChild.getAttribute('data-waielastline'));
      fixIELastLineCounter++;
    }

    if (isCreate)
    {
      this.fixIELastLineRemoveFixer();

      element = pEditor.iFrameDoc.createElement(elementTag);
      element.setAttribute('type', 'hidden');
      element.setAttribute('data-waielastline', '1');
      pEditor.iFrameDoc.body.appendChild(element);
    }
  };


  this.fixIELastLineRemoveFixer = (win, doc) =>
  {
    win = win || pEditor.iFrame;
    doc = doc || win.document;

    let i,
        elementTag = (pEditor.isEditorInViewMode ? 'DIV' : 'INPUT'),
        elements = doc.body.querySelectorAll(elementTag + '[data-waielastline]');

    for (i = elements.length; i--;)
    {
      elements[i].outerHTML = elements[i].innerHTML;
    }
  };


  this.fixNewDivToP = () =>
  {
    let lists = pEditor.iFrameDoc.body.querySelectorAll('OL:not([data-wacontent]),UL:not([data-wacontent])');

    for (let i = lists.length; i--;)
    {
      let divs = lists[i].querySelectorAll('DIV');

      for (let n = divs.length; n--;)
      {
        if (!divs[n].hasAttribute('data-wacontent') || divs[n].getAttribute('data-wacontenttag') !== 'DIV')
        {
          divs[i].outerHTML = divs[i].innerHTML;
        }
      }
    }
  };


  this.removeBrokenInputMarkers = () =>
  {
    let i,
        elements = pEditor.iFrameDoc.body.querySelectorAll('INPUT[type="hidden"]');

    for (i = elements.length; i--;)
    {
      if (!elements[i].hasAttribute('id') && !elements[i].hasAttribute('name') && elements[i].style.display.toLowerCase() === 'none')
      {
        elements[i].parentNode.removeChild(elements[i]);
      }
    }
  };


  Object.defineProperty(this, 'fixWebKitSpanTM', { get: () => fixWebKitSpanTM, set: v => { fixWebKitSpanTM = v }});
  Object.defineProperty(this, 'isWebKitSpansCollected', { get: () => isWebKitSpansCollected, set: v => { isWebKitSpansCollected = v }});
}
